import Vue from 'vue'
import VueRouter from 'vue-router'
import { principal } from './routers.principal'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  routes: [
    ...principal
  ]
})
